import { render, staticRenderFns } from "./provinces.vue?vue&type=template&id=769b0a01&scoped=true&"
import script from "./provinces.vue?vue&type=script&lang=js&"
export * from "./provinces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b0a01",
  null
  
)

export default component.exports